/* eslint-disable jsx-a11y/click-events-have-key-events */
import CardProgressIntroduction from 'components/molecules/card_progress_introduction';
import CourseStage from 'components/molecules/course_stage';
import React from 'react';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { useSelector } from 'react-redux';
import { ProgressionCourseState } from 'store/modules/progression_course_store/types';
import LoaderPayment from 'components/atoms/loader_payment';
// import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

const IntroductionSession = () => {
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { progression_course, request } = useSelector<ApplicationState, ProgressionCourseState>(
    (state) => state.session.progression_course,
  );

  const handleClick = () => {
    window.location.href = '/curso';
  };

  return (
    <Container>
      <div className="d-flex">
        <h4 className="pt-3 mr-3">Comece por aqui</h4>
        {/* {panel?.course_released && (
          <div className="d-md-flex d-block align-items-center py-3">
            <OpenTutorial type="modal" source="dashboard_beginner" />
          </div>
        )} */}
      </div>
      <div className="row">
        {request?.get_progression_course?.loaded ? (
          panel?.course_released || progression_course?.total_aula > 0 ? (
            <div className="col-md-6 position-relative">
              <CardProgressIntroduction />
            </div>
          ) : (
            <div
              className="col-md-6 position-relative"
              onClick={handleClick}
              role="button"
              tabIndex={0}
              aria-label="banner curso"
            >
              <div className="card-container bg-iaml h-100" aria-label="imagem banner curso" />
            </div>
          )
        ) : (
          <div className="col-md-6">
            <LoaderPayment />
          </div>
        )}

        <div className="col-md-6 mt-md-0 mt-3">
          <CourseStage />
        </div>
      </div>
    </Container>
  );
};

export default IntroductionSession;
